import React from "react"
import { Stack, Text } from "../../../vanilla"
import { LoqateField } from "../../loqate-field"
import { AddressFieldWithHiddenInputsProps } from "../../../types/cms/competition-marketing-form"
import { formatPostcode } from "../../../hooks/forms/useCheckPostcodeFields"

export const AddressFieldWithHiddenInputs = ({
  field,
  form,
  applyAddressToFormMarketing,
  hasError,
  subtext
}: AddressFieldWithHiddenInputsProps) => (
  <Stack spacing="4px">
    <LoqateField
      field={field}
      showAsterisk={true}
      setFoundedAddressToForm={applyAddressToFormMarketing}
      onSearchValueChange={(searchValue) => {
        form.setValue('address', searchValue, { shouldValidate: true })
        
        // Format and validate the postcode in searchForAddress
        const formattedPostcode = formatPostcode(searchValue).trim()
        form.setValue('searchForAddress', formattedPostcode, { shouldValidate: true })
        
        // Clear hidden fields when user manually edits the address
        form.setValue('address1', '', { shouldValidate: true })
        form.setValue('address2', '', { shouldValidate: false })
        form.setValue('city', '', { shouldValidate: false })
        form.setValue('postalCode', '', { shouldValidate: true })
      }}
      inputGroupProps={{style: {maxWidth: 450}}}
    />
    {/* Hidden fields to ensure form includes all required address fields */}
    <input type="hidden" {...form.register('address1')} />
    <input type="hidden" {...form.register('address2')} />
    <input type="hidden" {...form.register('city')} />
    <input type="hidden" {...form.register('postalCode')} />
    <input type="hidden" {...form.register('searchForAddress')} />
    {subtext && !hasError && (
      <Text variant="text1" color="textMuted">
        {subtext}
      </Text>
    )}
  </Stack>
)